import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-black text-sm">
      <div className="bg-black text-center mb-5 text-white p-2">
        <h2 className="text-lg font-semibold mb-2">CONTATO</h2>
        <a href='https://cf.coop.br/eleicao-delegados-2025/contato' className=" ">
          <p className="text-yellow-400">Fale com a CGE</p>
          <img
            src="https://www.cf.coop.br/wp-content/uploads/2025/08/envelope.png"
            alt="Logo COOPERFORTE"
            className="h-10 mb-1 mx-auto"
          /></a>
      </div>
      <div className="bg-[#BFBFBF] text-center text-sm py-3 px-4 font-sans font-medium">
        © Copyright {new Date().getFullYear()} <strong>COOPERFORTE</strong>. Todos os direitos reservados
      </div>
    </footer>
  );
};

export default Footer;
